import React from 'react';
import {
  TextFields,
  Notes,
  Numbers,
  ToggleOn,
  Home,
  CalendarMonth,
  DateRange,
  Schedule,
  TimerOutlined,
  FormatListBulleted,
  Image,
  PlayCircle,
  MusicNote,
  HelpOutline,
} from '@mui/icons-material';
import { FieldType } from '../../../../shared/types/appTypes';

interface FieldTypeIconProps {
  type: FieldType;
  fontSize?: 'small' | 'medium' | 'large' | 'inherit';
  color?: 'inherit' | 'action' | 'disabled' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

const FieldTypeIcon: React.FC<FieldTypeIconProps> = ({ type, fontSize = 'medium', color = 'inherit' }) => {
  const iconProps = { fontSize, color };

  switch (type) {
    case 'shortText':
      return <TextFields {...iconProps} />;
    case 'longText':
      return <Notes {...iconProps} />;
    case 'number':
      return <Numbers {...iconProps} />;
    case 'boolean':
      return <ToggleOn {...iconProps} />;
    case 'address':
      return <Home {...iconProps} />;
    case 'date':
      return <CalendarMonth {...iconProps} />;
    case 'dateRange':
      return <DateRange {...iconProps} />;
    case 'time':
      return <Schedule {...iconProps} />;
    case 'timeRange':
      return <TimerOutlined {...iconProps} />;
    case 'multipleChoice':
      return <FormatListBulleted {...iconProps} />;
    case 'imageChoice':
      return <Image {...iconProps} />;
    case 'video':
      return <PlayCircle {...iconProps} />;
    case 'appleMusicPlaylist':
      return <MusicNote {...iconProps} />;
    default:
      return <HelpOutline {...iconProps} />;
  }
};

export default FieldTypeIcon;
